import type Question from './Question'

export default class QuestionUsage implements Question {
  componentName = 'QuestionUsage'
  amount: string
  type: string
  frequency: string

  constructor(data: Partial<QuestionUsage> = {}) {
    this.amount = data?.amount ?? ''
    this.type = data?.type ?? ''
    this.frequency = data?.frequency ?? ''
  }

  isEmpty() {
    return !this.amount
  }

  reset() {
    this.amount = ''
    this.type = ''
    this.frequency = ''
  }
}
